/**
 * * FILE FOR GENERAL DROPDOWN FUNCTIONALITY
 * 
 * 
 * * HTML TEMPLATE - USE THIS TEMPLATE FOR DROPDOWNS TO WORK
 * 
 * <div id="placeholder" class="select-dropdown">
        <p class="label"><span data-title="filter name">filter name</span> 
			<?php get_template_part( 'template-parts/orange-arrow-stroke' ) ?>
		</p>
        <div class="options">
            <?php foreach ($array as $value) : ?>
                <a href="javascript:;" class="link" data-select="<?php echo $value; ?>" tabindex="-1">
                    <span><?php echo $value; ?></span>
                </a>
            <?php endforeach; ?>
        </div>
    </div>
 */

// * NOTE: most code for dropdowns will depend on the options, so will be done in the respective archive.js file - this file contains generic stuff that needs to happen for all dropdowns

const allDropdownOptionsElements = document.querySelectorAll(
	".select-dropdown .options"
);

// open dropdowns when clicking the label
$(".select-dropdown .label").on("click keypress", (e) => {
	if (e.type == "click" || e.key == "Enter") {
		toggleDropdown(e);
	}
});

// remove other active classes from the same dropdown, add to target and show selected filter in label - remove active class if target is already active
$(".select-dropdown .options .link").on("click keypress", (e) => {
	if (e.type == "click" || e.key == "Enter") {
		const target = $(e.target);
		const dropdown = target.closest(".select-dropdown");

		const dropdownLinks = [
			...document.querySelectorAll(".select-dropdown .options.open .link"),
		];

		updateActiveFilterInDropdown(target, dropdown);
		dropdownLinks.forEach((link) => {
			$(link).attr("tabindex", "-1");
		});

		$(".select-dropdown .options.open").removeClass("open");
		dropdown.children(".label").focus();
	}
});

// listen for clicks outside the open dropdown to close it
$("body").on("click", (e) => {
	if (!$(e.target).hasClass("label")) {
		const dropdownOptions = document.querySelectorAll(".options .link");

		dropdownOptions.forEach((option) => {
			option.setAttribute("tabindex", "-1");
		});

		$(".options.open").removeClass("open");
	}
});

function toggleDropdown(event) {
	const btn = $(event.target);
	const openTarget = btn.siblings(".options");
	let dropdownOptions;

	// open target - or close if already open
	if (openTarget.hasClass("open")) {
		openTarget.removeClass("open");
	} else {
		$(".options.open").removeClass("open");
		openTarget.addClass("open");

		dropdownOptions = document.querySelectorAll(".options.open .link");

		// add tab functionality if open
		dropdownOptions.forEach((option) => {
			option.setAttribute("tabindex", "0");
		});
	}

	// remove tab functionality for closed dropdowns
	dropdownOptions = document.querySelectorAll(".options:not(.open) .link");

	dropdownOptions.forEach((option) => {
		option.setAttribute("tabindex", "-1");
	});
}

function updateActiveFilterInDropdown(target, dropdown) {
	const options = document.querySelectorAll(".options.open .link span");
	const labelSpan = $(dropdown).find(".label span");
	const targetSpan = target.children("span");
	const targetSpanText = targetSpan.text();

	options.forEach((option) => {
		if ($(option).hasClass("active") && $(option).text() !== targetSpanText) {
			$(option).removeClass("active");
		}
	});

	// change label text and toggle active class on targetSpan
	if (
		window.location.pathname !== "/investments/" &&
		window.location.pathname !== "/investments"
	) {
		if (
			(targetSpanText != "All" && targetSpan.hasClass("active")) ||
			targetSpanText == "All"
		) {
			labelSpan.text(labelSpan.data("title"));
		} else {
			labelSpan.text(targetSpanText);
		}

		targetSpan.toggleClass("active");
	}
}
